<div class="auth login d-flex">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

        <div class="login-header text-center">
          <img src="/assets/img/videobyte-logo.svg" alt="" width="200"/>
        </div>

        <div class="login-content">
          <mat-card *ngIf="!tokenExpired; else tokenExpiredError" class="p-5 mb-5">
            <mat-card-title class="mb-4 pb-3 text-center">
              <i class="fal fa-info-circle fa-3x mb-3 d-block text-primary" aria-hidden="true"></i>
              <strong>Set new Password</strong>
              <!-- <small class="row mt-3 justify-content-center">Some text</small> -->
            </mat-card-title>
            <mat-card-content>
              <div>
                <form [formGroup]="form" class="d-flex flex-column">
                  <mat-form-field floatLabel="" [ngClass]="form?.get('newPassword').errors?.password ? 'mb-3' : 'mb-2'" appearance="outline">
                    <mat-label>Choose password</mat-label>
                    <input #email
                           matInput
                           placeholder="New password"
                           name="newPassword" value=""
                           required
                           type="password"
                           [errorStateMatcher]="errorStateMatcher"
                           formControlName="newPassword">
                  <mat-error *ngIf="form?.get('newPassword').errors?.password">Password must be min. 8 characters long and have at least one upper case, digit and special character</mat-error>
                  </mat-form-field>
                  <mat-form-field floatLabel="" [ngClass]="form?.get('confirmPassword').errors?.password && form?.get('confirmPassword').errors?.compare ? 'mb-5' : (form?.get('confirmPassword').errors?.password ? 'mb-3' : 'mb-2')" appearance="outline">
                    <mat-label>Confirm password</mat-label>
                    <input #email
                           matInput
                           placeholder="Confirm password"
                           name="confirmPassword" value=""
                           required
                           type="password"
                           [errorStateMatcher]="errorStateMatcher"
                           formControlName="confirmPassword">
                  <mat-error *ngIf="form?.get('confirmPassword').errors?.password">Password must be min. 8 characters long and have at least one upper case, digit and special character</mat-error>
                  <mat-error *ngIf="form?.get('confirmPassword').errors?.compare">Passwords do not match!</mat-error>
                  </mat-form-field>
                </form>
              </div>
            </mat-card-content>
            <mat-card-footer class="text-center">
              <button type="button" mat-flat-button color="primary" class="iconed large" (click)="submit()"
                      [disabled]="form.invalid">
                <span>Submit</span>
              </button>
            </mat-card-footer>
          </mat-card>

          <small class="d-block text-center text-white mt-n3">
            <p class=" hand" (click)="navigateToLogin()">Back to Login</p>
          </small>

        </div>

      </div>
    </div>
  </div>
</div>

<ng-template #tokenExpiredError>
  <mat-card class="p-5 mb-5">
    <mat-card-content>
      <div class="text-center">
        Token expired or not valid. Please try to <a class="link hand" (click)="navigateToResetPassword()">reset password</a> again.
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
